<template>
  <div>
    <Modal :title="title" v-model="modalShow" width="1000" footer-hide>
      <Alert show-icon type="error" v-if="errorMsgShow">{{ errorMsg }}</Alert>
      <Alert show-icon type="error" v-if="getDataError">获取数据失败</Alert>
      <div class="req-form" v-else>
        <p style="color: #19be6b">已绑定的安全组 <Badge :count="allocated_data.length" type="success"></Badge>：</p>
        <Table
          size="small"
          highlight-row
          :loading="tableOneLoading"
          ref="table"
          :height="allocated_data.length > 7 ? 300 : 0"
          :data="allocated_data"
          :columns="allocated_columns">
        </Table>
        <br/>
        <p style="color: #108ee9">可选安全组 <Badge :count="available_data.length" type="normal"></Badge>：</p>
        <Table
          size="small"
          highlight-row
          :loading="tableTwoLoading"
          ref="table"
          :height="available_data.length > 7 ? 300 : 0"
          :data="available_data"
          :columns="available_columns">
        </Table>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudServer, getPrivateCloudServerSecurityGroups } from '@/api/private-cloud/server'
import { getPrivateCloudAllSecurityGroup } from '@/api/private-cloud/security-group'
export default {
  name: 'server-set-security-group',
  data () {
    return {
      title: '编辑安全组',
      allocated_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          key: 'description'
        },
        {
          title: '',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              props: {
                loading: this.submitting
              },
              on: {
                click: () => {
                  this.down(params.row._index)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      allocated_data: [],
      available_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          key: 'description'
        },
        {
          title: '',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              props: {
                loading: this.submitting
              },
              on: {
                click: () => {
                  this.up(params.row._index)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],
      available_data: [],
      tableOneLoading: false,
      tableTwoLoading: false,
      server_id: '',
      modalShow: false,
      submitting: false,
      errorMsg: '',
      errorMsgShow: false,
      getDataError: false
    }
  },
  methods: {
    openModal (id) {
      this.server_id = id
      this.allocated_data = []
      this.available_data = []
      this.modalShow = true
      this.getAllSecurityGroupList()
    },
    // 获取安全组
    getAllSecurityGroupList () {
      this.tableOneLoading = true
      this.tableTwoLoading = true
      this.getDataError = false
      getPrivateCloudServerSecurityGroups(this.server_id).then(resS => {
        this.allocated_data = resS.data
        this.tableOneLoading = false
        let allocatedIds = []
        for (let i in resS.data) {
          allocatedIds.push(resS.data[i].id)
        }
        getPrivateCloudAllSecurityGroup().then(res => {
          this.available_data = []
          for (let v in res.data) {
            if (allocatedIds.indexOf(res.data[v].id) === -1) {
              this.available_data.push(res.data[v])
            }
          }
          this.tableTwoLoading = false
        }).catch(res => {
          this.getDataError = true
        })
      }).catch(res => {
        this.getDataError = true
      })
    },
    down (index) {
      let reqData = {
        removeSecurityGroup: {
          name: this.allocated_data[index].id
        }
      }
      this.available_data.push(this.allocated_data[index])
      this.allocated_data.splice(index, 1)
      this.submit(reqData)
    },
    up (index) {
      let reqData = {
        addSecurityGroup: {
          name: this.available_data[index].id
        }
      }
      this.allocated_data.push(this.available_data[index])
      this.available_data.splice(index, 1)
      this.submit(reqData)
    },
    submit (reqData) {
      this.submitting = true
      actionPrivateCloudServer(reqData, this.server_id).then(res => {
        this.submitting = false
        this.$Notice.success({
          title: '操作成功！'
        })
        this.$emit('callback')
      }).catch(res => {
        this.submitting = false
        this.getAllSecurityGroupList()
        if (res.request) {
          this.errorMsg = res.request.responseText
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.errorMsg = '操作失败！'
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        this.errorMsgShow = true
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    padding-right: 10px;
    max-height: 700px;
    overflow-y: auto;
    padding-bottom: 30px;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
